import React from 'react';
import { FormattedMessage } from 'react-intl';

import useDynamicLink from '../../../hooks/useDynamicLink';
import { DA_DIREKT_CROSS_SELLING_DENTAL_URL, imgLinks } from '../../../shared';

import {
  DA_DIREKT_FONT,
  StyledDaDirektCrossSellingCard,
  StyledDaDirektCrossSellingCardButton,
  StyledDaDirektCrossSellingCardContent,
  StyledDaDirektCrossSellingCardDaDirektLogo,
  StyledDaDirektCrossSellingCardText,
  StyledDaDirektCrossSellingCardTitle,
  StyledDaDirektDentalCrossSellingImageWrapper,
} from './DaDirektCrossSellingCard.styled';

const DA_DIREKT_LOGO_LINK = imgLinks['icon.menu.dadirekt.dark'];
const DA_DIREKT_DENTAL_BG_IMAGE_DESKTOP = imgLinks['image-da-dental-cross-selling-desktop'];

function DaDirektDentalCard({ trackingparams }) {
  useDynamicLink([DA_DIREKT_FONT]);

  const dentalCrossSellingUrl = `${DA_DIREKT_CROSS_SELLING_DENTAL_URL}?${trackingparams}`;

  const goToCrossSellingLink = () => {
    window.open(dentalCrossSellingUrl, '_blank');
  };

  return (
    <StyledDaDirektCrossSellingCard product="dental">
      <StyledDaDirektCrossSellingCardContent>
        <StyledDaDirektCrossSellingCardTitle>
          <FormattedMessage id="promotion.carousel.da_direkt.dental.cross_selling.title" />
        </StyledDaDirektCrossSellingCardTitle>

        <StyledDaDirektCrossSellingCardText>
          <FormattedMessage id="promotion.carousel.da_direkt.dental.cross_selling.text" />
        </StyledDaDirektCrossSellingCardText>

        <StyledDaDirektCrossSellingCardButton onClick={goToCrossSellingLink}>
          <FormattedMessage id="promotion.carousel.da_direkt.cross_selling.button.label" />
        </StyledDaDirektCrossSellingCardButton>
      </StyledDaDirektCrossSellingCardContent>

      {/* DA Direkt logo */}
      <StyledDaDirektCrossSellingCardDaDirektLogo src={DA_DIREKT_LOGO_LINK} alt="DA Direkt logo" />

      <StyledDaDirektDentalCrossSellingImageWrapper>
        <img src={DA_DIREKT_DENTAL_BG_IMAGE_DESKTOP} alt="DA Direkt dental" />
      </StyledDaDirektDentalCrossSellingImageWrapper>
    </StyledDaDirektCrossSellingCard>
  );
}

export default DaDirektDentalCard;
